import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { OrchestratorService } from '@services/orchestrator/orchestrator.service';
import { Observable } from 'rxjs';

export const SessionExpireGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const orchestrator = inject(OrchestratorService);
  const router = inject(Router);

  return orchestrator.sessionExpiredGuard(router, state.url);
};
